import React from 'react';

/**
 * État vide soigné (aucune donnée) — encadré discret, style refonte.
 * `tone='error'` pour un état d'erreur (bordure/texte rouge).
 */
const EmptyState: React.FC<{
  title: string;
  hint?: string;
  tone?: 'neutral' | 'error';
  className?: string;
}> = ({ title, hint, tone = 'neutral', className = '' }) => {
  const isErr = tone === 'error';
  return (
    <div
      className={`text-center border border-dashed rounded-card px-5 py-8 ${
        isErr ? 'border-st-bad/30 bg-st-bad/5' : 'border-line-2 bg-panel-2'
      } ${className}`}
    >
      <p className={`text-[13px] font-semibold ${isErr ? 'text-st-bad' : 'text-dim'}`}>{title}</p>
      {hint && <p className="text-[11.5px] text-faint mt-1">{hint}</p>}
    </div>
  );
};

export default EmptyState;
